import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ThanksForOrdering() {
  const { t } = useTranslation();
  
  return (
    <>
      <main className="relative bg-white min-h-screen lg:min-h-full">
        {/* Image Section - Full height on desktop */}
        <div className="h-64 sm:h-80 overflow-hidden lg:absolute lg:inset-y-0 lg:left-0 lg:h-full lg:w-1/2">
          <img
            src="https://res.cloudinary.com/dc6xthiol/image/upload/v1774695420/success_ahheeo.jpg"
            alt={t('thanksForOrdering.successImageAlt')}
            className="h-full w-full object-cover object-center"
          />
        </div>

        {/* Content Section */}
        <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8 lg:py-32">
          <div className="lg:grid lg:grid-cols-2 lg:gap-x-8 xl:gap-x-24">
            <div className="lg:col-start-2">
              {/* Success Badge */}
              <div className="flex items-center space-x-2 mb-4">
                <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center">
                  <svg className="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h1 className="text-sm font-medium text-green-600 uppercase tracking-wide">
                  {t('thanksForOrdering.paymentSuccessful')}
                </h1>
              </div>
              
              {/* Main Title */}
              <p className="mt-2 text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
                {t('thanksForOrdering.thanksForOrdering')}
              </p>
              
              {/* Description */}
              <div className="mt-6 text-base text-gray-500 space-y-4">
                <p className="text-lg">
                  {t('thanksForOrdering.appreciation')}
                </p>
                <p>
                  {t('thanksForOrdering.processingMessage')}
                </p>
              </div>
              
              {/* Order Summary Card - Optional */}
              <div className="mt-8 bg-gray-50 rounded-lg p-6 border border-gray-200">
                <h3 className="text-sm font-medium text-gray-900 mb-4">
                  {t('thanksForOrdering.whatsNext')}
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center">
                        <span className="text-xs font-bold text-blue-600">1</span>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600">
                      {t('thanksForOrdering.step1')}
                    </p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center">
                        <span className="text-xs font-bold text-blue-600">2</span>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600">
                      {t('thanksForOrdering.step2')}
                    </p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center">
                        <span className="text-xs font-bold text-blue-600">3</span>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600">
                      {t('thanksForOrdering.step3')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-8 flex flex-col sm:flex-row gap-4 border-t border-gray-200 pt-8">
                <Link
                  to="/customer-profile"
                  className="inline-flex items-center justify-center rounded-md border border-transparent bg-orange-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 transition-colors"
                >
                  <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  {t('thanksForOrdering.viewOrderStatus')}
                </Link>
                <Link
                  to="/all-categories"
                  className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-6 py-3 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 transition-colors"
                >
                  <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  {t('thanksForOrdering.continueShopping')}
                </Link>
              </div>
              
              {/* Support Text */}
              <p className="mt-8 text-sm text-gray-400 text-center sm:text-left">
                {t('thanksForOrdering.supportMessage')}
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}